export default __webpack_public_path__ + "static/media/banjaluka_net.a9c412f4.png";